export function requestPointerLockSafe(target: HTMLElement | null | undefined): void {
  if (target == null || typeof target.requestPointerLock !== 'function' || document.pointerLockElement === target) {
    return;
  }

  try {
    const maybePromise = target.requestPointerLock();
    if (maybePromise && typeof maybePromise.catch === 'function') {
      maybePromise.catch(() => {
        // Browsers can reject pointer lock outside a trusted gesture.
      });
    }
  } catch {
    // Browsers can also throw synchronously when pointer lock is unavailable.
  }
}
